export const LINHAS_POR_PAGINA = 6;

export function getOpcoesPeriodo(baseDate = new Date()) {
    return [-1, 0, 1].map(offset => {
        const date = new Date(baseDate.getFullYear(), baseDate.getMonth() + offset, 1);
        const mes = date.getMonth() + 1;
        const ano = date.getFullYear();

        return {
            label: `${String(mes).padStart(2, '0')}/${ano}`,
            value: `${mes}-${ano}`,
            mes,
            ano,
            isCurrent: offset === 0
        };
    });
}

export function formatMoeda(valor) {
    const numero = Number(valor);

    if (!Number.isFinite(numero)) {
        return 'R$ 0,00';
    }

    return numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
}

export function parseMoeda(texto) {
    const digitos = String(texto ?? '').replace(/\D/g, '');

    if (!digitos) {
        return 0;
    }

    return Number(digitos) / 100;
}

export function buildLinhaSaqueFacil(vendedor) {
    const numeroFilial = vendedor.idfilial != null
        ? vendedor.idfilial - 10000
        : null;
    const filial = numeroFilial != null
        ? (vendedor.nome_filial ? `${vendedor.nome_filial} - ${numeroFilial}` : String(numeroFilial))
        : '-';

    return {
        idvendedor: vendedor.idvendedor,
        nome: vendedor.nome_vendedor,
        filial,
        vendatotal: formatMoeda(vendedor.vendatotal)
    };
}

export function getColunasSaqueFacil() {
    return [
        { nome: 'Código', atributo: 'idvendedor', style: { minWidth: '110px', width: '110px' } },
        { nome: 'Nome', atributo: 'nome', style: { minWidth: '300px', width: '300px' } },
        { nome: 'Filial', atributo: 'filial', style: { minWidth: '240px', width: '240px' } },
        { nome: 'Venda total', atributo: 'vendatotal', style: { minWidth: '200px', width: '200px' } },
        { nome: 'Ação', atributo: 'acao', style: { minWidth: '90px', width: '90px', textAlign: 'center' } }
    ];
}

export function getLinhasPaginadas(rows, page) {
    if (!Array.isArray(rows)) {
        return rows;
    }

    const paginaAtual = Math.max(Number(page) || 1, 1);
    const inicio = (paginaAtual - 1) * LINHAS_POR_PAGINA;

    return rows.slice(inicio, inicio + LINHAS_POR_PAGINA);
}

export function getTotalPaginas(rows) {
    if (!Array.isArray(rows) || rows.length === 0) {
        return 1;
    }

    return Math.ceil(rows.length / LINHAS_POR_PAGINA);
}
